import React, { useState, useEffect, useRef } from 'react'
import { Form, Button, Row, Col, Alert } from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import Message from '../components/Message.js'
import Loader from '../components/Loader.js'
import { registerOwner } from '../actions/ownerActions.js'
import FormContainer from '../components/FormContainer.js'
import { OWNER_REGISTER_RESET } from '../constants/ownerConstants.js'

import 'react-phone-number-input/style.css'
import PhoneInput from 'react-phone-number-input'
// import { CountrySelect } from 'react-country-state-city'
// import 'react-country-state-city/dist/react-country-state-city.css'

// Register Owner Screen
const RegisterOwner = () => {
  const [fname, setFname] = useState('')
  const [lname, setLname] = useState('')
  const [email, setEmail] = useState('')
  const [phone, setPhone] = useState('')
  const [bname, setBname] = useState('')
  const [address, setAddress] = useState('')
  const [city, setCity] = useState('')
  const [state, setState] = useState('')
  const [country, setCountry] = useState('')
  const [mailcode, setMailcode] = useState('')
  const [password, setPassword] = useState('')
  const [confirmPassword, setConfirmPassword] = useState('')
  const [alert, setAlert] = useState({
    show: false,
    message: '',
    variant: 'success'
  })

  const dispatch = useDispatch()
  const navigate = useNavigate()
  const inputRef = useRef()

  function showAlert(message, variant = 'success', seconds = 2000) {
    setAlert({
      show: true,
      message,
      variant
    })

    setTimeout(() => {
      setAlert({
        show: false,
        message: '',
        variant: 'success'
      })
    }, seconds)
  }

  const ownerRegister = useSelector((state) => state.ownerRegister)
  const { loading, error, ownerInfo } = ownerRegister

  useEffect(() => {
    if (ownerInfo && !loading) {
      navigate('/owner/login/')
    } else {
      inputRef.current.focus()
    }
  }, [navigate, ownerInfo, dispatch, loading])

  useEffect(() => {
    dispatch({ type: OWNER_REGISTER_RESET })
  }, [dispatch])

  const submitHandler = (e) => {
    e.preventDefault()

    const ownerinfo = {
      fname,
      lname,
      email,
      phone,
      bname,
      address,
      city,
      state,
      country,
      mailcode,
      password
    }

    if (
      fname === '' ||
      lname === '' ||
      email === '' ||
      phone === '' ||
      bname === '' ||
      address === '' ||
      city === '' ||
      state === '' ||
      country === '' ||
      mailcode === '' ||
      password === ''
    ) {
      showAlert('Please enter all fields', 'danger')
      return
    }

    if (password !== confirmPassword) {
      showAlert('Passwords do not match', 'danger')
    } else if (password.length < 6) {
      showAlert('Password must be at least 6 characters', 'danger')
    } else {
      showAlert('Registration Successful', 'success')
      dispatch(registerOwner(ownerinfo))
    }
  }

  return (
    <FormContainer>
      <h4 className='my-2'>Owner Register</h4>
      {alert.show && <Alert variant={alert.variant}>{alert.message}</Alert>}
      {error && <Message variant='danger'>{error}</Message>}
      {loading && <Loader />}

      <Form onSubmit={submitHandler}>
        <Row className='mb-1'>
          <Col>
            <Form.Group className='mb-2' controlId='fname'>
              <Form.Label>First Name</Form.Label>
              <Form.Control
                ref={inputRef}
                type='fname'
                autoFocus
                placeholder='First Name'
                value={fname}
                onChange={(e) => setFname(e.target.value)}
                required
              />
            </Form.Group>
          </Col>
          <Col>
            <Form.Group className='mb-2' controlId='lname'>
              <Form.Label>Last Name</Form.Label>
              <Form.Control
                type='lname'
                placeholder='Last Name'
                value={lname}
                onChange={(e) => setLname(e.target.value)}
                required
              />
            </Form.Group>
          </Col>
        </Row>
        <Row className='mb-1'>
          <Col>
            <Form.Group className='mb-2' controlId='email'>
              <Form.Label>Email Address</Form.Label>
              <Form.Control
                type='email'
                placeholder='Email'
                autoComplete='on'
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </Form.Group>
          </Col>
          <Col>
            <Form.Group className='mb-2' controlId='phone'>
              <Form.Label>Phone Number</Form.Label>
              <PhoneInput
                defaultCountry='US'
                placeholder='Enter phone number'
                value={phone}
                onChange={setPhone}
              />
            </Form.Group>
          </Col>
        </Row>
        <Row className='mb-1'>
          <Col>
            <Form.Group className='mb-2' controlId='bname'>
              <Form.Label>Business Name</Form.Label>
              <Form.Control
                type='text'
                placeholder='Business Name'
                value={bname}
                onChange={(e) => setBname(e.target.value)}
                required
              />
            </Form.Group>
          </Col>
        </Row>
        <Row className='mb-1'>
          <Col>
            <Form.Group className='mb-2' controlId='address'>
              <Form.Label>Address</Form.Label>
              <Form.Control
                type='address'
                placeholder='Address'
                autoComplete='on'
                value={address}
                onChange={(e) => setAddress(e.target.value)}
                required
              />
            </Form.Group>
          </Col>
        </Row>
        <Row className='mb-1'>
          <Col>
            <Form.Group className='mb-2' controlId='city'>
              <Form.Label>City</Form.Label>
              <Form.Control
                type='city'
                placeholder='City'
                value={city}
                onChange={(e) => setCity(e.target.value)}
                required
              />
            </Form.Group>
          </Col>
          <Col>
            <Form.Group className='mb-2' controlId='state'>
              <Form.Label>State</Form.Label>
              <Form.Control
                type='state'
                placeholder=' State'
                value={state}
                onChange={(e) => setState(e.target.value)}
                required
              />
            </Form.Group>
          </Col>
        </Row>
        <Row className='mb-1'>
          <Col>
            <Form.Group className='mb-2' controlId='country'>
              <Form.Label>Country</Form.Label>
              {/* <CountrySelect
                value={country}
                containerClassName='form-group'
                inputClassName=''
                onChange={(_country) => setCountry(_country)}
                onTextChange={(_txt) => console.log(_txt)}
                placeHolder='Select Country'
              /> */}

              <Form.Control
                type='country'
                placeholder='Country'
                autoComplete='on'
                value={country}
                onChange={(e) => setCountry(e.target.value)}
                required
              />
            </Form.Group>
          </Col>
          <Col>
            <Form.Group className='mb-2' controlId='mailcode'>
              <Form.Label>Mail Code</Form.Label>
              <Form.Control
                type='mailcode'
                placeholder='Mail Code'
                value={mailcode}
                onChange={(e) => setMailcode(e.target.value)}
                required
              />
            </Form.Group>
          </Col>
        </Row>
        <Row className='mb-1'>
          <Col>
            <Form.Group className='mb-2' controlId='password'>
              <Form.Label>Password</Form.Label>
              <Form.Control
                type='password'
                placeholder='(6 or more characters)'
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
            </Form.Group>
          </Col>
          <Col>
            <Form.Group className='mb-2' controlId='confirmPassword'>
              <Form.Label>Confirm Password</Form.Label>
              <Form.Control
                type='password'
                placeholder='(6 or more characters)'
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                required
              />
            </Form.Group>
          </Col>
        </Row>

        <Button type='submit' variant='outline-primary' className='mt-3'>
          Register
        </Button>
        <Button
          variant='outline-secondary'
          className='mt-3 ms-2'
          onClick={() => navigate('/owner/login')}
        >
          Login Here
        </Button>
      </Form>
    </FormContainer>
  )
}

export default RegisterOwner
